<template>
  <div class="filters">
    <div class="row">
      <div class="col-sm-2">
        <select
          class="input-sm form-control input-s-sm inline"
          ref="resultsPerPage"
          @change="resultsPerPage"
        >
          <option disabled>Resultados por página</option>
          <option value="10" selected>10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>

      <div class="col-sm-3">
        <select
          v-if="statusList.length > 0"
          class="input-sm form-control input-s-sm inline"
          ref="resultsPerStatus"
          @change="resultsPerStatus"
        >
          <option disabled>Filtrar por</option>
          <option value="" selected>Todos</option>
          <option
            v-for="(status, index) in statusList"
            :key="index"
            :value="status.id"
          >
            {{ status.name }}
          </option>
        </select>
      </div>

      <div class="col-sm-4 col-sm-offset-3">
        <form @submit.prevent="searchKeyword">
          <div class="input-group">
            <input
              type="search"
              placeholder="Localizar registro"
              class="input-sm form-control"
              ref="searchKeyword"
            >
            <span class="input-group-btn">
              <button type="submit" class="btn btn-default btn-sm">
                <span class="fa fa-search"></span>
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Filters',
  props: {
    statusList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    resultsPerPage () {
      this.$emit('resultsPerPage', this.$refs.resultsPerPage.value)
    },

    resultsPerStatus () {
      this.$emit('resultsPerStatus', this.$refs.resultsPerStatus.value)
    },

    searchKeyword () {
      this.$emit('searchKeyword', this.$refs.searchKeyword.value)
      this.$refs.searchKeyword.value = ''
      this.$refs.searchKeyword.blur()
    }
  }
}
</script>

<style lang="scss" scoped>
.filters {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/datatable/Filters.vue